import { inject } from '@angular/core';
import { CanMatchFn, UrlSegment } from '@angular/router';
import { map } from 'rxjs';

import { UtilsService } from '@jht/brand-services';

import { InsightsService } from './insights.service';

export const matchInsights: CanMatchFn = (_route, segments: UrlSegment[]) => {
    if (segments.length === 1) {
        return true;
    }

    if (segments.length !== 2) {
        return false;
    }

    const insightsService = inject(InsightsService);
    const utilsService = inject(UtilsService);
    const slug = utilsService.slugify(segments[1].path);

    return insightsService
        .getInsightByTitle(slug)
        .pipe(map((insight) => Boolean(insight)));
};
